import { Spacer } from '@zillow/constellation';
import { Button, Text } from '@zillow/constellation-10';

import { MODES } from '../../constants';

import { StyledContainer, StyledSuccessIcon } from './StyledComponents';

import type { MODES_VALUES } from '../../constants';

const CONFIG = {
  phone: {
    bodyText: `Your number has been verified. You're done.`,
  },
  email: {
    bodyText: `Your email has been verified. You're done.`,
  },
};

type Props = {
  showVerificationModal: (value: boolean) => void;
  verificationSuccessfulCTAText: string;
  verificationMode?: MODES_VALUES;
};

const Finished = ({
  showVerificationModal,
  verificationSuccessfulCTAText,
  verificationMode = MODES.PHONE,
}: Props): JSX.Element => (
  <StyledContainer>
    <StyledSuccessIcon size="lg" />
    <Text textStyle="body-bold">Success!</Text>
    <Text css={{ marginTop: '200', textAlign: 'center' }} asChild>
      <p>{CONFIG[verificationMode].bodyText}</p>
    </Text>
    <Spacer marginTop="sm">
      <Button
        tone="brand"
        emphasis="filled"
        onClick={() => showVerificationModal(false)}
        css={{
          minWidth: '200px',
          display: 'block',
          margin: '0 auto',
        }}
      >
        {verificationSuccessfulCTAText}
      </Button>
    </Spacer>
  </StyledContainer>
);

export default Finished;
